import React from 'react';

import { ChatMessageDeleted } from '../ChatMessageDeleted';

type DeletedMessageProps = {
  text: string;
  incoming: boolean;
};

export function DeletedMessage({ text, incoming }: DeletedMessageProps) {
  return <ChatMessageDeleted text={text} incoming={incoming} />;
}
